import BaseClass from "../BaseClass";

export default class BestOffersHandler extends BaseClass {

    constructor(element) {
        super(element);
        this.mobileLayout = false;
        this.clientHeight = 0;
        this.init();
    }

    init() {

        let mySelf = this;

        $(document).on("content:resized", function () {
                mySelf.checkMobileLayout();
            }
        );

        $(document).on('content:loaded', function (event, data) {
            mySelf.initActionElements(event, data);
        });

        $(document).on('useroffer:loaded', function (event, data) {
            $(document).trigger('bestoffers:read');
        });

        $(window).on('popstate', function () {
            window.location.reload();
        });

        mySelf.checkMobileLayout();

        let checkUrlHash = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (checkUrlHash !== '' && checkUrlHash !== 'show') {
            mySelf.showBestOffers();
        }
    }

    showBestOffers() {
        if (this.mobileLayout) {
            $('#bestoffers_holder').removeClass('hidden');
            $('#creators_holder').addClass('hidden');
        }
    }

    hideBestOffers() {
        if (this.mobileLayout) {
            $('#bestoffers_holder').addClass('hidden');
            $('#creators_holder').removeClass('hidden');
        }
    }

    initActionElements() {
        let mySelf = this;
        let hasPurchasedOffer = false;

        if (mySelf.$element.hasClass('purchased')) {
            hasPurchasedOffer = true;
            mySelf.$element.removeClass('purchased');
        }

        let $trigger = this.$element.find('[data-button-type="reloadtrigger"][data-substate="init"]');

        if ($trigger != undefined) {
            $trigger.attr('data-substate', 'init_done');
            $trigger.on('click', function (data, event) {
                let url = data.currentTarget.dataset.bestofferUrl;
                window.history.pushState({}, '', url);
                mySelf.showBestOffers();
            });
        }

        let $backButton = this.$element.find('[data-type="backbutton"][data-state="init"]');

        if ($backButton != undefined) {
            $backButton.on('click', function (data) {
                let url = data.currentTarget.dataset.actionUrl;
                window.history.pushState({}, '', url);
                mySelf.hideBestOffers();
            });
        }

        if (hasPurchasedOffer) {
            mySelf.showBestOffers();
        }
    }

    checkMobileLayout() {

        if (this.getCurrentFullScreenElement() != null) {
            return false;
        }

        let minDesktopWidth = 992;
        let currentWidth = $(window).width();

        let currentHeight = document.documentElement.clientHeight;


        if (this.clientHeight != currentHeight) {

            this.clientHeight = currentHeight;

            if (minDesktopWidth > currentWidth) {
                if (!this.mobileLayout) {
                    this.mobileLayout = true;
                    $('#bestoffers_holder').addClass('hidden');
                    $('#creators_holder').removeClass('hidden');
                }
            } else {
                this.mobileLayout = false;
                $('#bestoffers_holder').removeClass('hidden');
                $('#creators_holder').removeClass('hidden');
            }
        }
    }

    destroyListener() {
        super.destroyListener();
    }
}